export const GET_ALL_LANGUAGES = "GET_ALL_LANGUAGES"
export const GET_ALL_LANGUAGES_SUCCESS = "GET_ALL_LANGUAGES_SUCCESS"
export const GET_ALL_LANGUAGES_ERROR = "GET_ALL_LANGUAGES_ERROR"

export const ADD_LANGUAGE = "ADD_LANGUAGE"
export const SET_CURRENT_LANGUAGE_CODE = "SET_CURRENT_LANGUAGE_CODE"
